import settings from "./settings";
import underwriting from "./underwriting";

export default {
  settings,
  underwriting
};
